/**
 * Dummy User master-specific translation keys
 */
export const dummyUser = {
  list: {
    search_placeholder: "admin.dummy_user_search_placeholder",
    main_heading: "admin.dummy_user_list_heading",
    create_btn_text: "admin.dummy_user_create_btn_text",
    table: {
      created_at_col_heading: "admin.dummy_user_created_at_table_col_heading",
      full_name_col_heading: "admin.dummy_user_full_name_table_col_heading",
      email_col_heading: "admin.dummy_user_email_table_col_heading",
      username_col_heading: "admin.dummy_user_username_table_col_heading",
      status_col_heading: "admin.dummy_user_status_table_col_heading",
      action_col_heading: "admin.dummy_user_action_table_col_heading",
    },
    status: {
      online: "admin.dummy_user_status_online",
      offline: "admin.dummy_user_status_offline",
    },
    status_filter_options: {
      all: "admin.dummy_user_status_filter_all",
      online: "admin.dummy_user_status_filter_online",
      offline: "admin.dummy_user_status_filter_offline",
    },
    delete_popup_heading_text: "admin.dummy_user_delete_popup_heading_text",
    delete_popup_message_text: "admin.dummy_user_delete_popup_message_text",
    delete_popup_yes_btn_text: "admin.dummy_user_delete_popup_yes_btn_text",
    delete_popup_no_btn_text: "admin.dummy_user_delete_popup_no_btn_text",
    status_popup_heading_text: "admin.dummy_user_status_popup_heading_text",
    status_popup_yes_btn_text: "admin.dummy_user_status_popup_yes_btn_text",
    status_popup_no_btn_text: "admin.dummy_user_status_popup_no_btn_text",
    clear_filter_btn_text: "admin.dummy_user_clear_filter_btn_text",
    view_tooltip: "admin.dummy_user_view_tooltip",
    edit_tooltip: "admin.dummy_user_edit_tooltip",
    delete_tooltip: "admin.dummy_user_delete_tooltip",
    defaults: {
      na: "admin.dummy_user_defaults_na",
    },
  },
  add: {
    main_heading: "admin.dummy_user_add_heading",
  },
  edit: {
    main_heading: "admin.dummy_user_edit_heading",
  },
  view: {
    main_heading: "admin.dummy_user_view_heading",
    first_name_label: "admin.dummy_user_view_first_name_label",
    last_name_label: "admin.dummy_user_view_last_name_label",
    email_label: "admin.dummy_user_view_email_label",
    bio_label: "admin.dummy_user_view_bio_label",
    about_me_label: "admin.dummy_user_view_about_me_label",
    date_of_birth_label: "admin.dummy_user_view_date_of_birth_label",
    gender_label: "admin.dummy_user_view_gender_label",
    preferred_language_label: "admin.dummy_user_view_preferred_language_label",
    house_number_label: "admin.dummy_user_view_house_number_label",
    street_label: "admin.dummy_user_view_street_label",
    city_label: "admin.dummy_user_view_city_label",
    country_label: "admin.dummy_user_view_country_label",
    zip_code_label: "admin.dummy_user_view_zip_code_label",
    latitude_label: "admin.dummy_user_view_latitude_label",
    longitude_label: "admin.dummy_user_view_longitude_label",
    status_label: "admin.dummy_user_view_status_label",
    created_at_label: "admin.dummy_user_view_created_at_label",
    last_online_label: "admin.dummy_user_view_last_online_label",
    back_btn_text: "admin.dummy_user_view_back_btn_text",
    tabs: {
      personal_info: "admin.dummy_user_view_tab_personal_info",
      profile_details: "admin.dummy_user_view_tab_profile_details",
      education: "admin.dummy_user_view_tab_education",
      work_experience: "admin.dummy_user_view_tab_work_experience",
      interests_appearances: "admin.dummy_user_view_tab_interests_appearances",
    },
    personal_info: {
      title: "admin.dummy_user_view_personal_info_title",
    },
    profile_details: {
      title: "admin.dummy_user_view_profile_details_title",
    },
    education: {
      title: "admin.dummy_user_view_education_title",
      school: "admin.dummy_user_view_education_school",
      graduation_year: "admin.dummy_user_view_education_graduation_year",
      primary: "admin.dummy_user_view_education_primary",
      secondary: "admin.dummy_user_view_education_secondary",
      no_education_info: "admin.dummy_user_view_no_education_info",
    },
    work_experience: {
      title: "admin.dummy_user_view_work_experience_title",
      company: "admin.dummy_user_view_work_company",
      industry: "admin.dummy_user_view_work_industry",
      employment_type: "admin.dummy_user_view_work_employment_type",
      no_work_info: "admin.dummy_user_view_no_work_info",
    },
    interests_appearances: {
      interests_title: "admin.dummy_user_view_interests_title",
      appearances_title: "admin.dummy_user_view_appearances_title",
      no_interests: "admin.dummy_user_view_no_interests",
      no_appearances: "admin.dummy_user_view_no_appearances",
    },
    defaults: {
      na: "admin.dummy_user_defaults_na",
    },
    error: {
      not_found: "admin.dummy_user_view_error_not_found",
      not_found_description: "admin.dummy_user_view_error_not_found_description",
      back_to_list: "admin.dummy_user_view_error_back_to_list",
    },
  },
  form: {
    first_name_label: "admin.dummy_user_first_name_label",
    first_name_placeholder: "admin.dummy_user_first_name_placeholder",
    last_name_label: "admin.dummy_user_last_name_label",
    last_name_placeholder: "admin.dummy_user_last_name_placeholder",
    email_label: "admin.dummy_user_email_label",
    email_placeholder: "admin.dummy_user_email_placeholder",
    password_label: "admin.dummy_user_password_label",
    address_search_label: "admin.dummy_user_address_search_label",
    address_search_placeholder: "admin.dummy_user_address_search_placeholder",
    house_number_label: "admin.dummy_user_house_number_label",
    house_number_placeholder: "admin.dummy_user_house_number_placeholder",
    street_label: "admin.dummy_user_street_label",
    street_placeholder: "admin.dummy_user_street_placeholder",
    city_label: "admin.dummy_user_city_label",
    city_placeholder: "admin.dummy_user_city_placeholder",
    country_label: "admin.dummy_user_country_label",
    country_placeholder: "admin.dummy_user_country_placeholder",
    zip_code_label: "admin.dummy_user_zip_code_label",
    zip_code_placeholder: "admin.dummy_user_zip_code_placeholder",
    coordinates_missing_note: "admin.dummy_user_coordinates_missing_note",
    maps_not_configured_note: "admin.dummy_user_maps_not_configured_note",
    maps_loading_note: "admin.dummy_user_maps_loading_note",
    maps_key_rejected_note: "admin.dummy_user_maps_key_rejected_note",
    submit_btn_text: "admin.dummy_user_submit_btn_text",
    update_btn_text: "admin.dummy_user_update_btn_text",
    cancel_btn_text: "admin.dummy_user_cancel_btn_text",
    loading_btn_text: "admin.dummy_user_loading_btn_text",
  },
};
